export default __webpack_public_path__ + "static/media/goredrinker.facf5796.png";